import dynamic from 'next/dynamic';

// with the 'ssr: false' option ensures that this component is only loaded and executed on the client side. Because QuillEditor relies on browser-specific APIs that are not available during SSR
export const TextEditor = dynamic(() => import('./QuillEditor'), { ssr: false });
